<template>
  <div class="modal-backdrop">
    <div class="modal">
      <div
        class="bg-green-8 bg-cover fixed left-0 right-0 bottom-0 top-0 text-center"
        @click="continueGame()"
      >
        <div class="absolute left-0 right-0 top-20 w-full mx-auto">
          <img class="mx-auto" src="../assets/images/icon-emote4.svg" alt="" />
          <div class="mt-5 mx-10" v-if="this.language == 'en'">
              <!-- TODO:
                - Kondisi copytext easy breazy
                - dynamic emoticon senang / sedih
                - point
              -->
            <h2 class="text-6xl text-white font-bold">{{ title }}</h2>
            <p class="text-xs text-white mt-2">{{ description }}</p>
            <span class="text-2xl text-white font-black"
              >LEVEL {{ level }} {{ $t('game_modal_done_text_1') }}</span
            >
          </div>
          <div class="mt-5 mx-10" v-else>
              <!-- TODO:
                - Kondisi copytext easy breazy
                - dynamic emoticon senang / sedih
                - point
              -->
            <h2 class="text-6xl text-white font-bold">{{ titleThai }}</h2>
            <p class="text-xs text-white mt-2">{{ descriptionThai }}</p>
            <span class="text-2xl text-white font-black"
              >LEVEL {{ level }} {{ $t('game_modal_done_text_1') }}</span
            >
          </div>
          <div 
            class="mt-10 mx-20 py-3 px-5 bg-green-5 rounded-3xl relative"
            style="box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.3);"
          >
            <img
              class="absolute left-0 right-0 -top-5 mx-auto"
              src="../assets/images/star-white-big.svg"
              alt=""
            />
            <h1
              class="text-9xl text-green-3 font-black"
              style="-webkit-text-stroke: 7px white; text-shadow: 5px 8px 10px rgb(0 0 0 / 40%);"
            >
              {{ totalPoint }}
            </h1>
            <p class="text-white text-xl">{{ $t('game_modal_done_text_2') }}</p>
          </div>
        </div>
        <div class="absolute left-0 right-0 bottom-0">
          <img class="w-full" src="../assets/images/game-level-complete-coffee.png" alt="" v-if="this.language == 'en'" />
          <img class="w-full" src="../assets/images/level-complete-bg-th.png" alt="" v-else/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Howl, Howler } from 'howler';
export default {
  name: "ModalLevelComplete",
  props: [
    'level',
    'pointLevel1',
    'pointLevel2',
    'pointLevel3',
  ],
  data() {
    return {
      totalPoint: 0,
      title: '',
      description: '',
      language: '',
    }
  },
  mounted () {
    this.language = process.env.VUE_APP_I18N_LOCALE
		console.log(this.language)
  },
  created() {
    this.$store.commit('PLAY_AUDIO', false)
    this.$parent.$parent.sfx.gameLevelComplete.play()
    // Howler.unload();
      switch (this.level) {
        case 1:
          this.title = 'EASY BREEZY!';
          this.titleThai = 'ง่ายๆ ชิลๆ!';
          this.description = 'DRINK SOME, WIN SOME';
          this.descriptionThai = 'เคี้ยวบ้าง สไลด์บ้าง สร้างคะแนน';
          this.totalPoint = this.pointLevel1;
          break;
        case 2:
          this.title = 'SO FRESH!';
          this.titleThai = 'สดชื่น ถึงใจ!';
          this.description = 'MINTS & COFFEE FRESHEN UP THE MOOD';
          this.descriptionThai = 'การเคี้ยวหมากฝรั่ง หลังมื้ออาหาร ช่วยให้ลมหายใจสดชื่น';
          this.totalPoint = this.pointLevel2;
          break;
        case 3:
          this.title = 'SUPER COOL!';
          this.titleThai = 'เจ๋งสุดๆ !';
          this.description = 'THAT CAFFEINE HIT SURELY KICKS IN';
          this.descriptionThai = 'ลมปากสดชื่นและพุงอันยิ่งใหญ่ มาพร้อมกับรางวัลที่ใหญ่ยิ่ง';
          this.totalPoint = this.pointLevel3;
          break;
      }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    continueGame() {
      // this.$parent.$parent.sfx.touch.play()
      this.$emit("continueGames");
    },
  },
};
</script>
